import "./notification-strip.scss";

import { motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";

import SvgIcon from "@client/components/reusable/SvgIcons";
import { ReactComponent as CloseIcon2 } from "@client/components/reusable/SvgIcons/library/close_icon2.svg";
import { ReactComponent as MailYellow } from "@client/components/reusable/SvgIcons/library/mail-yellow.svg";

interface NotificationStripProps {
	title: string;
	message: string;
	onClose: () => void;
}

const NotificationStrip = ({
	title,
	message,
	onClose,
}: NotificationStripProps) => {
	const contentRef = useRef<HTMLDivElement>(null);
	const [height, setHeight] = useState<number>(0);

	useEffect(() => {
		if (contentRef.current) {
			setHeight(contentRef.current.scrollHeight);
		}
	}, [title, message]);

	return (
		<motion.div
			className="notification-strip-wrapper"
			initial={{ height: 0, opacity: 0 }}
			animate={{ height: height, opacity: 1 }}
			exit={{ height: 0, opacity: 0 }}
			transition={{ duration: 0.3, ease: "easeInOut" }}
		>
			<div ref={contentRef} className="notification-strip">
				<div className="notification-strip-icon">
					<SvgIcon
						width="20"
						height="20"
						component={MailYellow}
						className="mail-icon-yellow"
					/>
				</div>

				<div className="notification-strip-content">
					<span className="notification-strip-title">{title}</span>
					<span className="notification-strip-message">{message}</span>
				</div>

				<button className="notification-strip-close" onClick={onClose}>
					<SvgIcon
						size="24"
						height="24"
						width="24"
						component={CloseIcon2}
						className="overlay-close-icon"
					/>
				</button>
			</div>
		</motion.div>
	);
};

export default NotificationStrip;
